export enum Roles {
  OmniAdmin = "omni-admin",
  SalesForceManager = "sales-force-manager",
  AreaManager = "area-manager",
  MedicalRepresentative = "medical-representative",
}
